import React from 'react';
import { Tooltip } from 'antd';

import {
  formatRelativeDate,
  parseDisplayDate,
} from '@totem/components/common/dateDisplay/dateDisplayUtils';

type Props = {
  date: string;
};

// Renders a date as "Just now", "3 h ago", "Yesterday", "4 d ago", etc.,
// with the full timestamp in a tooltip.
const RelativeDate = ({ date }: Props) => {
  const parsed = parseDisplayDate(date);
  if (parsed === null) {
    return <span>-</span>;
  }

  return (
    <Tooltip title={parsed.toLocaleString()}>
      <span style={{ whiteSpace: 'nowrap' }}>{formatRelativeDate(parsed)}</span>
    </Tooltip>
  );
};

export default RelativeDate;
